import { profileStore } from '/src/stores/profile.js';
import { replace } from '../core.js';
export function rootRouteHandler(processRoute) {
    if (profileStore.isLoggedIn) {
        replace('/my-playlists', processRoute);
    }
    else {
        replace('/sign-in', processRoute);
    }
}
